import styles from "./SavedPermissionRecovery.module.css";
import type { UseToolPermissionsResult } from "../../hooks/useToolPermissions";

// Kept outside the catalog tool-list guard: retired tools/providers still have
// enforceable policy, even when there are no currently available tools to show.
export const SavedPermissionRecovery = ({ policy, tools, unavailable = false }: {
  policy: UseToolPermissionsResult;
  tools: ReadonlyArray<{ slug: string }>;
  unavailable?: boolean;
}) => {
  if (!policy.data) return null;
  const available = new Set(tools.map(tool => tool.slug.toUpperCase()));
  const retired = policy.data.rules.filter(rule => !available.has(rule.toolSlug.toUpperCase()));
  if (!unavailable && retired.length === 0 && policy.data.rules.length === 0 && policy.data.defaultPermission === "allow") return null;
  return <section className={styles.panel} aria-label="Saved tool permissions">
    {unavailable ? <>
      <h2>Saved tool permissions</h2>
      <p>This integration is unavailable. Its saved permissions still apply.</p>
      <p>Default permission: {policy.data.defaultPermission}</p>
    </> : null}
    {retired.length > 0 ? <>
      <p>Saved rules for tools no longer in the available catalog:</p>
      <ul>{retired.map(rule => <li key={rule.toolSlug}>
        <code>{rule.toolSlug}</code>: {rule.permission}{" "}
        {policy.data!.canEdit ? <button className={styles.button} type="button" disabled={policy.saving}
          onClick={() => void policy.clearPermission(rule.toolSlug)}>Reset {rule.toolSlug} to default</button> : null}
      </li>)}</ul>
    </> : null}
    {policy.data.canEdit ? <>
      <p>Resetting removes all saved rules and allows every action for this integration.</p>
      <button className={styles.button} type="button" disabled={policy.saving} onClick={() => void policy.resetAll()}>Reset all permissions to Allow</button>
    </> : <p>Only owners and managers can change permissions.</p>}
    {policy.error ? <p role="alert">Couldn&apos;t change saved permissions. Please try again.</p> : null}
  </section>;
};
